<template>
  <div class="c-location-detail c-location-detail--left">
    <FavoriteToggle :location="location" />
    <div class="c-feature-location__store-address">
      <p>
        <b>{{ getOpenHours(location) }}</b>
      </p>
    </div>
    <div class="c-feature-location__store-address">
      <p>
        {{ location.address }}<br />
        <span v-if="location.address_2">
          {{ location.address_2 }} <br />
        </span>
        {{ location.city }}, {{ location.region }}
        {{ location.postalCode }}
      </p>
    </div>
    <div class="c-feature-location__action-items">
      <a :href="`tel:${location.mainPhone}`" class="c-feature-location__store-map-link" :aria-label="`Store telephone number ${location.mainPhone}`">
        <img :src="`${assetPath}images/icons/phone-icon.svg`" alt="Phone Icon" />
        <span>{{ location.mainPhone }}</span></a
      >
      <a :href="mapUrl(location)" class="c-feature-location__store-map-link" aria-label="Get directions link">
        <img :src="`${assetPath}images/icons/map-icon.svg`" alt="Get directions icon" />
        <span>Get Directions</span>
      </a>
    </div>
    <a
      :href="mapUrl(location)"
      :aria-label="`${location.name} Location Map Link`"
      class="c-feature-location__store-info-map"
      :style="`background: url(/perch/resources/${location.locationDynamicFields.c_mapTilePerch.path}) center center;background-size:cover;background-repeat:no-repeat;`"
    >
    </a>
    <div class="c-feature-location__store-hours">
      <p><b>store hours</b></p>
      <ul class="store-hours">
        <li v-for="(hour, index) in storeHours" :key="index" :style="{ fontWeight: today === index ? 'bold' : 'normal' }">
          <span>{{ returnDay(hour.day) }}</span>
          <span v-if="!isClosed(hour.hours)">{{ hour.hours[0] }} - {{ hour.hours[1] }}</span
          ><span v-else>Closed</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import FavoriteToggle from '@/components/FavoriteToggle';
import { store } from '@/store';
export default {
  props: ['location', 'mapUrl'],
  components: { FavoriteToggle },
  data() {
    return {
      storeHours: [],
      assetPath: store.assetPath(),
      perchPath: store.perchPath(),
    };
  },

  mounted() {
    Object.keys(this.location.hours).map((hour) => {
      if (this.location.hours[hour].open === "00:00:00" && this.location.hours[hour].closed === "00:00:00") {
        this.storeHours.push({ day: hour, isClosed: true });
      } else {
        let currentDay = this.location.hours[hour];
        this.storeHours.push({
          day: hour,
          hours: Object.keys(currentDay).map((hour) =>
            this.tConvert(currentDay[hour])
          ),
          isClosed: false
        });
      }
    });
  },
  computed: {
    today() {
      let date = new Date();
      return date.getDay() - 1;
    },
  },
  methods: {
    tConvert(time) {
      // Check correct time format and split into components
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      delete time[4];

      if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[4] = +time[0] < 12 ? ' am' : ' pm'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join(''); // return adjusted time or original string
    },
    forceHttps(location) {
      return location.replace(/^http:\/\//i, 'https://');
    },
    getOpenHours(location) {
      const d = new Date();
      let day = d.getDay();
      let dayIndex;

      if (day === 0) {
        dayIndex = 6;
      } else {
        dayIndex = day - 1;
      }

      if ((this.storeHours[dayIndex] && this.storeHours[dayIndex].hours) && (this.storeHours[dayIndex].isClosed === true || (this.storeHours[dayIndex].hours[0] === "12:00 am" && this.storeHours[dayIndex].hours[1] === "12:00 am"))) {
        return "Closed Today"
      } else if (this.storeHours[dayIndex]) {
        return "Open today from " + this.storeHours[dayIndex].hours[0] + " to " + this.storeHours[dayIndex].hours[1];
      } else {
        return '';
      }

    },
    returnDay(day) {
      switch (day) {
        case 'sunday':
          return 'Sunday';
        case 'monday':
          return 'Monday';
        case 'tuesday':
          return 'Tuesday';
        case 'wednesday':
          return 'Wednesday';
        case 'thursday':
          return 'Thursday';
        case 'friday':
          return 'Friday';
        case 'saturday':
          return 'Saturday';
        default:
        // code block
      }
    },
    isClosed(arr) {
      if (arr && (arr[0] === "12:00 am" && arr[1] === "12:00 am")) {
        return true;
      } else {
        return false;
      }
    }
  },
};
</script>
